export default __webpack_public_path__ + "static/media/blank-canvas.3a87c90d.svg";